import { render, staticRenderFns } from "./RegistrantAside.vue?vue&type=template&id=89103b7e&scoped=true"
import script from "./RegistrantAside.vue?vue&type=script&lang=js"
export * from "./RegistrantAside.vue?vue&type=script&lang=js"
import style0 from "./RegistrantAside.vue?vue&type=style&index=0&id=89103b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89103b7e",
  null
  
)

export default component.exports